import { Component, ViewChild } from '@angular/core';
import { DashboardHeaderComponent } from 'src/app/private/shared/components/dashboard-header/dashboard-header.component';
import { SmartSuggestionCustomAction } from 'src/app/private/shared/enums/smart-suggestions.enum';
import { FEATURE_FLAGS } from 'src/app/private/shared/services/unleash/unleash.helpers';
import { UnleashService } from 'src/app/private/shared/services/unleash/unleash.service';

@Component({
  selector: 'app-coach-dashboard-page',
  templateUrl: './coach-dashboard.component.html',
  styleUrls: ['./coach-dashboard.component.scss'],
  standalone: false,
})
export class CoachDashboardComponent {
  @ViewChild('dashboardHeader') dashboardHeader: DashboardHeaderComponent;

  smartSuggestionsEnabled = false;

  instantFeedbackEnabled = false;

  constructor(private featureFlagService: UnleashService) {
    this.smartSuggestionsEnabled = this.featureFlagService.isEnabled(
      FEATURE_FLAGS.smartSuggestions
    );

    this.instantFeedbackEnabled = this.featureFlagService.isEnabled(
      FEATURE_FLAGS.instantFeedbackCard
    );
  }

  customSuggestionAction($event: string) {
    switch ($event) {
      case SmartSuggestionCustomAction.QUICK_WALK_MODAL:
        this.dashboardHeader.openQuickWalkModal();
        break;
      default:
        break;
    }
  }
}
